module.exports = __webpack_public_path__ + "static/img/logo@2x.ed100cc9.png";